// extracted by mini-css-extract-plugin
module.exports = {"img":"Card_img__qr-qd","h3":"Card_h3__3irYl","label":"Card_label__33GJ2","p":"Card_p__1C-fS"};